import { useEffect, useState } from "react";
import { getWatchList, type WatchList } from "./watchlist";

export function useWatchList(): WatchList {
  const [list, setList] = useState<WatchList>(() => getWatchList());
  useEffect(() => {
    const handler = () => setList(getWatchList());
    window.addEventListener("watchlist-changed", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("watchlist-changed", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);
  return list;
}
